import axios from "@/axios.js"
import Accounts from './accounts_service'
export default {

  fetchAllDBAccounts({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Accounts.getAllDBData(item, (rows, lastRow) => {
        // console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
        });
    })
  },
  getCompanyOrRegistrationNo({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/accounts/search_company_or_registration/" + item)
        .then((response) => {
          commit('SET_COMPANY_OR_REGISTRATION_NO', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSatelliteOffices({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/accounts/get_satellite_offices/" + item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getCompanyFromTempAccounts({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/get_temp_accounts", {
          item: item
        }).then((response) => {
          commit('SET_COMPANY_OR_REGISTRATION_NO', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getCompanyFromMasterDatabase({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/get_company_from_master_database", {
          item: item
        }).then((response) => {
          commit('SET_COMPANY_OR_REGISTRATION_NO', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAccountsMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_account_meta/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getMasterMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_master_meta/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSatelliteOfficeMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_satellite_office_meta/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getWebMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_web_meta/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getLinkedinMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_linkedin_meta/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getPhoneMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_phone_meta/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSicCodeMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_siccode_metadata/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getRegistrationJurisdictionMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_registration_jurisdiction_metadata/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getParentMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_parent_metadata/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getVerticalMetaData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/metadata/get_vertical_metadata/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getVertical({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/accounts/get_vertical/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getCountry({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/accounts/get_country/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getParent({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/accounts/${item}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getGroupCompanies({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/accounts/get_grouped_companies/${item}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  checkLinkedinExists({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/check_linkedin_exists", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  checkWebsiteExists({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/check_website_exists", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  checkCompanyExists({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/check_company_exists", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  searchAutocomplete({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/accounts/search/" + item)
        .then((response) => {
          // // console.log(response)
          commit('SET_AUTOCOMPLETE_DATA', response.data.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateAccount({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/update_account", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          commit('ADD_ITEM', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addAccount({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/add_accounts", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          commit('ADD_ITEM', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addAccountAndAddToCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/add_accounts_and_add_to_campaign", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  dropAccountsFromCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/drop_accounts_from_campaign", {
          item: item
        })
        .then((response) => {
      
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getPhoneTypes({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/accounts/phone_types")
        .then((response) => {
          // // console.log(response)
          commit('SET_PHONE_TYPES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getVerticals({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/accounts/verticals/" + item)
        .then((response) => {
          commit('SET_VERTICALS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getCountries({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/accounts/countries/" + item)
        .then((response) => {
          commit('SET_COUNTRIES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSicCodes({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/accounts/sic_codes/" + item)
        .then((response) => {
          commit('SET_SIC_CODES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAllSicCodes({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/accounts/get_all_sic_codes")
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAllVerticals({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/accounts/get_all_verticals")
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAllCurrencyCodes({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/accounts/get_all_currency_codes")
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getPhoneCodes({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/accounts/phone_codes/" + item)
        .then((response) => {
          commit('SET_PHONE_CODES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAllPhoneCodes({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/accounts/all_phone_codes")
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getCurrencyCodes({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/accounts/get_currency_codes")
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllAccountLists({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/get_all_account_lists", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAccount(context, accountId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/accounts/${accountId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
    fetchAccountList({
      commit
    },item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/accounts/${item}`)
        .then((response) => {
          commit('SELECTED_ACCOUNT', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeAccount({
    commit
  }, accountId) {
    return new Promise((resolve, reject) => {
      // alert(accountId)
      axios.delete(`/api/accounts/${accountId}`)
        .then((response) => {
          commit('REMOVE_ACCOUNT', accountId)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchExistingAccountsForCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Accounts.getExistingAccountsForCampaignData(item, (rows, lastRow) => {
        // console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
        });
    })
  },
  fetchAllAccountsForCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Accounts.getData(item, (rows, lastRow) => {
        // console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
        });
    })
  },
  getRemainAccounts({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Accounts.getRemainAccountsData(item, (rows, lastRow) => {
        // console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
        });
    })
  },
  getRejectedAccounts({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Accounts.getRejectedAccountsData(item, (rows, lastRow) => {
        // console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
        });
    })
  },
  fetchAllExtraEnrichedAccounts({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Accounts.getExtraEnrichedData(item, (rows, lastRow) => {
        // console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
        });
    })
  },
  fetchAllSDQCAccounts({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Accounts.fetchAllSDQCAccounts(item, (rows, lastRow) => {
        resolve({ rows: rows, lastRow: lastRow })
        });
    })
  },
  fetchAllSDQCContacts({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Accounts.fetchAllSDQCContacts(item, (rows, lastRow) => {
        // console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
        });
    })
  },
  fetchAllSDQCContactsForChangeGradeFilter({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Accounts.fetchAllSDQCContactsForChangeGradeFilter(item, (rows, lastRow) => {
        // console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
        });
    })
  },
  fetchAllSDQCContactsForAssignContact({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Accounts.fetchAllSDQCContactsForAssignContact(item, (rows, lastRow) => {
        // console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
        });
    })
  },
  fetchAllQualityControlContacts({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Accounts.fetchAllQualityControlContacts(item, (rows, lastRow) => {
        // console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
        });
    })
  },
  fetchAllQualityControlAccounts({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Accounts.fetchAllQualityControlAccounts(item, (rows, lastRow) => {
        // console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
        });
    })
  },
  fetchAllMatchedAccountsOfCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Accounts.fetchAllMatchedAccountsOfCampaign(item, (rows, lastRow) => {
        // console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
        });
    })
  },
  fetchAllMatchedAccountsListOfCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Accounts.fetchAllMatchedAccountsListOfCampaign(item, (rows, lastRow) => {
        // console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
        });
    })
  },
  fetchAllMatchedContactOfCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Accounts.fetchAllMatchedContactOfCampaign(item, (rows, lastRow) => {
        // console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
        });
    })
  },
  fetchAllMatchedAccountAssociatedMasterContacts({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Accounts.fetchAllMatchedAccountAssociatedMasterContacts(item, (rows, lastRow) => {
        // console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
        });
    })
  },
  fetchDBAccountsContacts({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Accounts.getDBAccountsContacts(item, (rows, lastRow) => {
        // console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
        });
    })
  },
  fetchDBAccountsList({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Accounts.fetchDBAccountsList(item, (rows, lastRow) => {
        // console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
        });
    })
  },

  enhanceAccountAfterML({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/enhance_account_after_ml", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  remainingUnmatchedAccount({
    commit
  }, item) {
  return new Promise((resolve, reject) => {
    Accounts.remainingUnmatchedAccount(item, (rows, lastRow) => {
      resolve({ rows: rows, lastRow: lastRow })
      });
  })
  },
  enrichAccountDataToMasterDB({
    commit
  }, item) {
  return new Promise((resolve, reject) => {
    Accounts.enrichAccountDataToMasterDB(item, (rows, lastRow) => {
      resolve({ rows: rows, lastRow: lastRow })
      });
  })
  },
  updateOtherFieldAccountData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/update_other_field_account_data", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateMasterDBAccount({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/update_master_db_account", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
    updateMasterDBAccountFromCompare({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/update_master_db_account_from_compare", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
      updateMasterDBAccountFromValidateSDAccount({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/update_master_db_account_from_validate_sd_account", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
       updateMasterDBAccountFromClientView({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/update_master_db_account_from_client_view", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  ignoreMasterDBAccount({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/ignore_master_db_account", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  ignoreMasterDBAccountFromValidateSDAccount({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/accounts/ignore_master_db_account_from_validate_sd_account", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
ignoreMasterDBAccountFromValidateClientView({
  commit
}, item) {
  return new Promise((resolve, reject) => {
    axios.post("/api/accounts/ignore_master_db_account_from_validate_client_view", {
        item: item
      })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
},
  IgnoreUpdateToAccountField({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/ignore_account_field_data", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateOldCsvAccountData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/update_old_csv_account_data", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  ignoreCsvAccountNewData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/ignore_new_csv_account_data", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSDfetchAccount({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/get_a_sd_qc_account_description", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSDfetchContact({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/get_a_sd_qc_contact_description", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateSDQCAccount({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/update_sd_qc_account", {
          item: item
        })
        .then((response) => {
    
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateSDQCContact({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/update_sd_qc_contact", {
          item: item
        })
        .then((response) => {
    
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllSDQCAccountsForClientSide({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/get_all_sd_accounts_client_side", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllSDQCAccountsForClientSideFilterGradeChanged({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/get_all_sd_accounts_client_side_filter_grade_changed", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllSDQCContactsForClientSideFilterGradeChanged({
    commit
  }, item) {


    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/get_all_sd_contacts_client_side_filter_grade_changed", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllSDQCAccountsForClientSideFilterAuditTrialChanged({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/get_all_sd_accounts_client_side_filter_audit_trial_changed", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllSDQCContactsForClientSideFilterAuditTrialChanged({
    commit
  }, item) {


    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/get_all_sd_contacts_client_side_filter_audit_trial_changed", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getUnassociatedContacts({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/get_unassociated_contacts_client_side", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllSDQCAccountFieldsForClientSide({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/get_all_sd_accounts_fields_client_side", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllSDQCContactFieldsForClientSide({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/get_all_sd_contacts_fields_client_side", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },


  fetchAllClientViewAccountFieldsForClientSide({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/get_all_client_view_accounts_fields_client_side", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllClientViewContactFieldsForClientSide({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/get_all_client_view_contacts_fields_client_side", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllSDQCAccountsFromLastStament({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/fetch_all_sd_accounts_from_last_statement", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateQCNumbers({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/update_qc_numbers", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllAccountDataSourceForClientView({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Accounts.getAccountDataSourceForClientView(item, (rows, lastRow) => {
        // console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
        });
    })
  },
  fetchAllContactDataSourceForClientView({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Accounts.getContactDataSourceForClientView(item, (rows, lastRow) => {
        // console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
        });
    })
  },
  getSDViewAccount({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/get_a_sd_view_account_description", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getClientViewAccount({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/get_a_client_view_account_description", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getClientViewAccountFromClientTable({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/get_a_client_view_account_description_from_client_table", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSDViewContact({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/get_a_sd_view_contact_description", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getClientViewContact({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/get_a_client_view_contact_description", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  importPredata({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/pre_data/import/pre_data", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  writeDataToCSVTABLE({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/pre_data/import/write_data_to_csv_table", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  writeNetherlandDataToMasterDatabase({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/pre_data/import/write_netherland_data_to_master_db", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  writeAllExistingContactsToTempCampaignContactsTable({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/pre_data/import/writeAllExistingContactsToTempCampaignContactsTable", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateDbUpdatedFlag({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/pre_data/import/update_db_updated_flag", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  importUKCompanyData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/pre_data/import/account_uk_companies", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  importGermanyCompanyData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/pre_data/import/account_germany_companies", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  importUKGermanyContactData({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/pre_data/import/uk_germany_account_contacts", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllMatchedCampaignAccountsClientSide({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/get_all_matched_campaign_accounts_client_side", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllMasterDBAccountsForCampaign({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      Accounts.fetchAllMasterDBAccountsForCampaign(item, (rows, lastRow) => {
        // console.log(lastRow)
        resolve({ rows: rows, lastRow: lastRow })
        });
    })
  },
  updateSDQCAccountAndClientViewAccount({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/update_sd_qc_account_and_client_view_account", {
          item: item
        })
        .then((response) => {
    
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateSDQCContactAndClientViewContact({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/update_sd_qc_contact_and_client_view_contact", {
          item: item
        })
        .then((response) => {
    
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateHasDifferentValueAfterUpdate({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/accounts/has_different_value_after_update_flag", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}
